/* eslint-disable prettier/prettier */
/* eslint-disable import/prefer-default-export */
export const LOGIN = '/login';
export const DASHBOARD = '/';
export const SIGN_UP = '/sign-up';
export const PROFILE = '/profile/:username';
export const NOT_FOUND = '/not-found';
export const VIEW_ALLSUGGESTION = '/suggested'
